import { formatPhone } from "@rhema/client";
import { Button, Sheet } from "@rhema/ui";
import { useMemo, useState } from "react";
import { renderSVG } from "uqr";
import { useMe } from "../session/session";
import { useMyChatLink } from "./InviteSheet";
import { ShareTargets } from "./ShareTargets";

const INK = "#161A26";
const LINEN = "#F8F7F3";

/** Your QR code: it holds your chat link, so scanning it opens a chat with you. */
export function MyQrCode() {
  const me = useMe();
  const link = useMyChatLink();
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState<string | null>(null);
  const svg = useMemo(
    () => (link ? renderSVG(link, { pixelSize: 8, blackColor: INK, whiteColor: LINEN }) : ""),
    [link],
  );
  if (!link || !me.phone) return null;

  return (
    <>
      <Button variant="ghost" className="bg-linen" onClick={() => setOpen(true)}>
        My QR code
      </Button>
      <Sheet
        open={open}
        onClose={() => {
          setOpen(false);
          setNote(null);
        }}
        title="My QR code"
        subtitle="People who scan it can message you on Rhema"
        className="px-5 pb-7"
      >
        <div className="mt-4 flex flex-col items-center gap-3">
          <div
            role="img"
            aria-label={`QR code for ${link}`}
            className="w-full max-w-[260px] overflow-hidden rounded-card border border-line bg-linen p-3 [&_svg]:h-auto [&_svg]:w-full"
            // biome-ignore lint/security/noDangerouslySetInnerHtml: uqr builds this SVG from the link alone
            dangerouslySetInnerHTML={{ __html: svg }}
          />
          <p className="m-0 font-serif text-xl font-medium">{me.display_name}</p>
          <p className="m-0 text-sm text-ink-secondary">{formatPhone(me.phone)}</p>
          {note && (
            <p role="status" className="m-0 text-[13px] text-ink-secondary">
              {note}
            </p>
          )}
          <div className="w-full">
            <ShareTargets
              text={`Message me on Rhema: ${link}`}
              url={link}
              subject="Message me on Rhema"
              qrCode={false}
              onResult={(r) => setNote(r.note ?? null)}
            />
          </div>
        </div>
      </Sheet>
    </>
  );
}
